<template>
    <div class="box" v-if="!$store.state.user.cookieTip">
        <div>
            <div class="title">Cookies on our site</div>
            <p>
                This website uses technical cookies,which are necessary for you to browse it and which help us to
                provide the service.With your consent,we use profiling cookies to offer you an increasingly agreeable
                browsing experience,to facilitate interaction with our social-media features,and to enable you to
                receive marketing messages tailored to your browsing habits and interests. To accept all profiling
                cookies,click ACCEPT;to decline,click REFUSE.For more information about the cookies we use.
            </p>
        </div>
        <div class="btn">
            <button @click="REFUSE">REFUSE</button>
            <button @click="ACCEPT">ACCEPT</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    methods: {
        REFUSE() {
            this.$store.commit('user/cookieTip', 'REFUSE')
        },
        ACCEPT() {
            this.$store.commit('user/cookieTip', 'ACCEPT')
        },
    },
    created() {},
}
</script>

<style lang="less" scoped>
.box {
    background-color: #242424;
    background-color: rgba(0, 0, 0, 0.95);
    position: fixed;
    bottom: 0px;
    z-index: 1001;
    color: #fff;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    padding: 20px;
    height: 160px;
    line-height: 22px;
    font-family: Arial, Helvetica, sans-serif;
    display: flex;
    & > div {
        flex: 10;
    }
    .title {
        font-size: 22px;
        margin-bottom: 10px;
    }

    .btn {
        display: flex;
        flex: 3;
        justify-content: center;
        margin-top: 30px;
        button {
            margin: 0 8px;
            width: 90px;
            /* prettier-ignore */
            min-width: 80PX;
            line-height: 40px;
            height: 40px;
            border: 1px solid #fff;
            color: #fff;
            outline: none;
            font-weight: bold;
            font-family: Arial, Helvetica, sans-serif;
            cursor: pointer;
            background-color: transparent;
            // background-color: #f5f1f2;
        }
        button:hover {
            background-color: #e2dfe0;
            color: #242424;
            border: 1px solid #242424;
        }
    }
}
</style>
